import React from "react";

export const loadableWithChunkRecovery = (factory: () => Promise<any>) =>
  React.lazy(() =>
    factory().catch((err) => {
      console.error("Lazy load failed:", err);
      return Promise.reject(err);
    })
  );
